<template>
    <v-container>
        <v-row>
            <v-col cols="cols">
                terms
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  export default {
    name: 'Terms'
  }
</script>

<style scoped>

</style>
